// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { PopoverTokens } from './type';

const popoverTokens: PopoverTokens = {
  popoverFontSize: '14/regular',
  popoverPaddingX: 'Padding-8',
  popoverPaddingY: 'Padding-8',
  popoverRadius: 'Radius-4',
  popoverBorderWidth: 'Border-1',
  popoverFontColor: 'Neutral-text-5',
  popoverBackgroundColor: 'Neutral-fill-1',
  popoverShadow: 'Shadow-2',
  popoverBorderColor: 'Neutral-border-1',
  popoverSuccessBackgroundColor: '#edf9e8',
  popoverSuccessBorderColor: 'rgba(82, 196, 26, 0.1)',
  popoverWarningBackgroundColor: '#fff3e5',
  popoverWarningBorderColor: 'rgba(255, 140, 0, 0.1)',
  popoverInfoBackgroundColor: '#e8f1fe',
  popoverInfoBorderColor: 'rgba(25, 122, 250, 0.1)',
  popoverDangerBackgroundColor: '#ffeded',
  popoverDangerBorderColor: 'rgba(255, 77, 80, 0.1)',
  popoverErrorFontColor: 'Danger-7',
  popoverErrorBackgroundColor: 'Danger-1',
  popoverErrorBorderColor: 'Danger-1',
  popoverConfirmPaddingX: 'Padding-16',
  popoverConfirmPaddingY: 'Padding-16',
  popoverConfirmBackgroundColor: 'transparent',
};

export default popoverTokens;
